const noCache = 'no-cache';
const cacheFirst = 'cache-first';
const FETCH_POLICY_MAPPING = {
    GetCountries: cacheFirst,
    GetCmsBlocks: cacheFirst,
    GetCmsPage: cacheFirst,
    GetProduct: cacheFirst,
    GetCategory: cacheFirst,
    GetCategoryBanner: cacheFirst,
    GetMenu: cacheFirst,
    GetScandiCategory: cacheFirst,
    GetYmal: cacheFirst,
    GetProductDynamic: noCache,
    ProcessHCResult: noCache,
    IsEmailAvailable: noCache,
    ProcessPendingOrder: noCache,
    GetCurrencies: cacheFirst,
    UrlResolver: noCache,
    GetHotelSelectorCountries: noCache,
    Search: cacheFirst,
    QuickSearch: cacheFirst,
    GetCart: noCache,
    GetCustomerAddress: noCache,
    GetWishlist: noCache,
    GetCartItemsAmount: noCache,
    AddSimpleProduct: noCache,
    AddMultipleSimpleProducts: noCache,
    AddConfigurableProduct: noCache,
    UpdateItemQuantity: noCache,
    RemoveItem: noCache,
    GetCustomerInfo: noCache,
    GetOrder: noCache,
    GetOrdersList: noCache,
    GetGuestOrderByToken: noCache,
    GetGuestOrderManually: noCache,
    GetPromotion: cacheFirst,
    GetAllProducts: cacheFirst,
    GetAllCategories: cacheFirst,
    GetAlmaPaymentMethod: noCache,
    SetPaymentMethodAndPlaceOrder: noCache,
};
const fetchPolicyLookup = (fetchKey) => {
    const fetchPolicy = FETCH_POLICY_MAPPING[fetchKey];
    if (!fetchPolicy)
        throw new Error('FETCH KEY WITHOUT POLICY IN FETCH MAPPING');
    return fetchPolicy;
};

export { fetchPolicyLookup as default, fetchPolicyLookup };
//# sourceMappingURL=fetchPolicyLookup.js.map
